import { useQueryClient } from "@tanstack/react-query";
import {
  useAuthQuery,
  useAuthMutation,
  UseQueryExtendedOptions,
} from "@bn/api";
import {
  AccountSelectGroup,
  createSelectGroups,
  getSelectedGroup,
  upsertSelectedGroup,
} from "@api/v1/methods";
import { GET_SELECTED_GROUP } from "../../cacheKeys";

export type AccountGroupName =
  | "depotAnalysis"
  | "investmentList"
  | "householdBook"
  | "dividendPlanner"
  | "dashboard";

export type GetSelectedGroupParams = {
  groupName: AccountGroupName;
  accountType?: string;
  excludeManuallyMaintainedFallbackAccounts?: boolean;
};

export const useCreateSelectedGroups = () =>
  useAuthMutation(createSelectGroups);

export const useGetSelectedGroup = (
  params: GetSelectedGroupParams,
  options: UseQueryExtendedOptions<
    AccountSelectGroup,
    AxiosApiError,
    AccountSelectGroup
  > = {
    enabled: true,
  }
) =>
  useAuthQuery(
    [GET_SELECTED_GROUP, params],
    ({ token }) =>
      getSelectedGroup(
        token,
        params.groupName,
        params.accountType,
        params.excludeManuallyMaintainedFallbackAccounts
      ),
    options
  );

export const useUpdateSelectedGroup = (groupKey: AccountGroupName) => {
  const queryClient = useQueryClient();
  return useAuthMutation(upsertSelectedGroup, {
    onSuccess: (result) => {
      if (!result) return;
      queryClient.setQueryData([GET_SELECTED_GROUP, groupKey], result.data);
    },
  });
};
